import { render, staticRenderFns } from "./chineseBox.vue?vue&type=template&id=2d0c329e&scoped=true"
import script from "./chineseBox.vue?vue&type=script&lang=js"
export * from "./chineseBox.vue?vue&type=script&lang=js"
import style0 from "./chineseBox.vue?vue&type=style&index=0&id=2d0c329e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c329e",
  null
  
)

export default component.exports